import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './HeroSlider.css';

const USER_ID = 'gowthama_pandian';
const TAXON_ID = '47792';

const HeroSlider = () => {
  const [slides, setSlides] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchRandomSlides = async () => {
      try {
        const res = await fetch(
          `https://api.inaturalist.org/v1/observations?user_id=${USER_ID}&taxon_id=${TAXON_ID}&per_page=15`
        );
        const data = await res.json();
        const results = data.results || [];
        
        // Shuffle and pick 5
        const shuffled = [...results].sort(() => 0.5 - Math.random());
        const selected = shuffled.slice(0, 5).map(obs => ({
          image: obs.photos[0]?.url.replace('square', 'large') || '',
          title: obs.taxon?.preferred_common_name || obs.taxon?.name || 'Odonata',
          scientific: obs.taxon?.name,
          location: obs.place_guess
        }));
        
        setSlides(selected);
      } catch (err) {
        console.error("Failed to fetch slideshow images", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchRandomSlides();
  }, []);

  useEffect(() => {
    if (slides.length > 0) {
      const timer = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % slides.length);
      }, 1000); // 1s interval
      return () => clearInterval(timer);
    }
  }, [slides]);

  if (isLoading) return <div className="slider-placeholder">Loading magic...</div>;
  if (slides.length === 0) return null;

  return (
    <div className="hero-slider">
      {slides.map((slide, index) => (
        <div 
          key={index} 
          className={`slide ${index === currentIndex ? 'active' : ''}`}
          style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.6)), url(${slide.image})` }}
        >
          <div className="slide-content">
            <h2 className="slide-title">{slide.title}</h2>
            <p className="slide-scientific"><em>{slide.scientific}</em></p>
            <p className="slide-location">{slide.location}</p>
          </div>
        </div>
      ))}
      
      <div className="slider-dots">
        {slides.map((_, index) => (
          <div 
            key={index} 
            className={`dot ${index === currentIndex ? 'active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;
